import React from 'react'
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

const Menu = (props) => (
    <nav id="menu">
        <div className="inner">
            <ul className="links">
                <li><Link onClick={props.onToggleMenu} to="/">Home</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/experience">Work</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/running">Running</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/motivation">Motivation</Link></li>
            </ul>
        </div>
        <a className="close" onClick={props.onToggleMenu} href="javascript:;">Close</a>
    </nav>
)

Menu.propTypes = {
    onToggleMenu: PropTypes.func
}

export default Menu
